module.exports = __webpack_public_path__ + "static/media/active-icon.38235e5f.svg";